import { Box, Button, Flex, Heading, Image, Input, Text } from '@chakra-ui/react'
import { useTranslation } from 'next-i18next/pages'

interface AffiliateBannerProps {
  account?: any
  affiliateLink?: string
  onCopy?: (link: string) => void
  onConnectWallet?: () => void
}

export const AffiliateBanner = ({ account, affiliateLink, onCopy, onConnectWallet }: AffiliateBannerProps) => {
  const { t } = useTranslation()

  return (
    <Flex
      alignItems={'center'}
      minH={{ base: '320px', sm: '360px', md: '400px' }}
      h={{ base: 'auto', md: '400px' }}
      rounded={'2xl'}
      bg={'ninja.600'}
      position={'relative'}
      overflow={'hidden'}
      py={{ base: 5, md: 0 }}
    >
      {/* Background image */}
      <Image
        src="/assets/images/partners/bg.webp"
        pos={'absolute'}
        alt=""
        w={'full'}
        h={'full'}
        objectFit={'cover'}
        inset={0}
      />
      {/* Hero image */}
      <Image
        src="/assets/images/partners/hero1.png"
        pos={'absolute'}
        alt=""
        display={{ base: 'none', lg: 'block' }}
        h={{ base: '180%', xl: '200%' }}
        w={'auto'}
        right={{ base: '0', xl: '40px' }}
        transform={'translateY(40%) translateX(20%)'}
        bottom={0}
        zIndex={5}
      />
      <Image
        src="/assets/images/partners/hero1.png"
        pos={'absolute'}
        alt=""
        display={{ base: 'block', lg: 'none' }}
        w={'auto'}
        h={{ base: '100%', sm: '100%', md: '100%' }}
        right={{ base: '-20px', sm: '0', md: '20px' }}
        top={'50%'}
        transform={'translateY(-30%) translateX(-10%)'}
        opacity={0.3}
        zIndex={1}
      />
      <Box pos={'relative'} zIndex={10} p={{ base: 3, sm: 4, md: 4, xl: 6 }} w={'full'}>
        <Heading
          lineHeight={1.2}
          fontSize={{ base: '22px', sm: '26px', md: '36px', lg: '48px' }}
          mb={{ base: 2, sm: 3, md: 8 }}
        >
          {t('affiliate.banner.title')}
        </Heading>
        <Text
          fontSize={{ base: '12px', sm: '13px', md: '16px' }}
          color={'ninja.100'}
          fontWeight={500}
          maxW={{ base: '100%', sm: '340px', md: '300px', xl: '300px' }}
          mb={{ base: 3, sm: 4, md: 6 }}
          lineHeight={1.5}
        >
          {t('affiliate.banner.description')}
        </Text>

        <Box maxW={{ base: '100%', sm: '380px', md: '400px', lg: '380px' }}>
          {account && affiliateLink ? (
            <Box>
              <Text fontWeight={700} mb={{ base: 1.5, md: 2 }} fontSize={{ base: 'xs', sm: 'sm', md: 'md' }}>
                {t('PartnershipModal.referral-link')}
              </Text>
              <Flex gap={2} mb={2} direction={{ base: 'column', sm: 'row' }} maxW={{ base: '100%', md: '400px' }}>
                <Input
                  h={{ base: 38, sm: 38, md: 40, lg: 38 }}
                  border={'none'}
                  bg={'ninja.800'}
                  color={'ninja.100'}
                  value={affiliateLink}
                  readOnly
                  fontSize={{ base: 'xs', sm: 'sm', md: 'sm' }}
                  px={{ base: 3, md: 3 }}
                />
                <Button
                  rounded={'lg'}
                  onClick={() => onCopy?.(affiliateLink)}
                  h={{ base: 38, sm: 38, md: 40, lg: 38 }}
                  minW={{ base: 'full', sm: '90px' }}
                  fontSize={{ base: 'sm', md: 'sm' }}
                  px={3}
                >
                  {t('common.button.copy')}
                </Button>
              </Flex>
            </Box>
          ) : (
            <Button
              variant="orange"
              fontSize={{ base: '14px', md: '14px' }}
              px={{ base: 8, md: 10, lg: 12 }}
              h={{ base: '44px', md: '52px', lg: '60px' }}
              rounded={{ base: '2xl', md: 'xl', lg: '2xl' }}
              onClick={onConnectWallet}
              w={{ base: 'full', sm: 'auto' }}
            >
              {t('affiliate.banner.become-partner')}
            </Button>
          )}
        </Box>
      </Box>
    </Flex>
  )
}
